import { Component, inject } from '@angular/core'
import { BaseComponent, Grid, FeatureType, ModalSize, County } from '../../shared'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { SafetyMeeting } from '../../shared'
import { SafetyMeetingComponent } from './meeting.component'
import { FormsModule } from '@angular/forms'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjBarcodeCommonModule } from '@grapecity/wijmo.angular2.barcode.common'

@Component({
    templateUrl: './meetings.component.html',
    styleUrls: ['./meetings.component.css'],
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        WjBarcodeCommonModule,
    ],
})
export class SafetyMeetingsComponent extends BaseComponent {
    faSearch = faSearch
    grid: Grid<SafetyMeeting>
    qrSize = 50
    fullScreenQr = ''
    showFullScreenQr = false
    safetyTrainings = [] as any[]

    constructor() {
        super()
        this.grid = new Grid<SafetyMeeting>(this.services)
            .setupModalEditing(
                this.services.data.safetyMeetings,
                'Safety Meeting',
                SafetyMeetingComponent,
                () => new SafetyMeeting(),
                this,
                ModalSize.medium,
            )
            .filterBy(item => [item.title])
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(true, true, this.services.data.safetyMeetings.queryAll(), this.services.data.get('/api/VpData/QuerySafetyTrainings'))
                .subscribe(
                    successResult => {
                        this.initialLoadingComplete()
                        this.grid.items = successResult[0]
                        this.safetyTrainings = successResult[1]
                    },
                    errorResult => {},
                ),
        )
    }

    getQrCodeUrl(id: string) {
        return window.location.origin + '/safety/attendee?id=' + id
    }

    toggleFullScreenQr(id: string, show: boolean) {
        this.fullScreenQr = encodeURI(window.location.origin + '/safety/attendee?id=' + id)
        this.showFullScreenQr = show
        this.services.angular.location
        console.log(this.fullScreenQr)
    }
    openMeeting() {
        window.open(this.fullScreenQr, '_blank')
    }

    get canEdit() {
        return this.services.authentication.hasFeature(<any>FeatureType.SafetyMeetingEdit)
    }
}
